<template>
    <div id="confirmMail_v2" class="font-source-sans">
        <div class="confirm_mail_title mb-5">
            <p>
                S'il vous plaît écrivez <br />
                votre adresse e-mail <br />
                et vous recevrez un lien <br />
                de récupération
            </p>
        </div>

        <div class="confirm_mail_auth">
            <p class="font-bold">E-mail</p>
            <div class="input_wrapper relative w-full mt-2 mb-5">
                <input class="input_mail" type="text" placeholder="Votre e-mail" v-model="form_confirm_mail.email" />
                <div class="email_img_wrapper">
                    <img src="img/auth/mail.svg" alt="" />
                </div>
            </div>

            <div class="buttons-wrapper flex justify-between mb-5">
                <button type="button" class="btn validate-btn" @click="loginConfirmMail">Valider</button>
            </div>
        </div>
    </div>
</template>

<script>
    import Autentification from '@/services/Autentification';
    export default {
        data() {
            return {
                form_confirm_mail: {
                    email: ''
                }
            };
        },
        methods: {
            clearConfirmMail() {
                var self = this;
                self.form_confirm_mail.email = '';
            },

            isValidEmail(email) {
                var re = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                return re.test(email) ? true : false;
            },

            loginConfirmMail() {
                var self = this;

                // preia datele
                self.form_confirm_mail.email = self.form_confirm_mail.email.trim().toLowerCase();
                //
                // valideaza datele
                if (self.form_confirm_mail.email.length === 0) {
                    $eventbus.$emit('open:alert', 'Merci de préciser votre e-mail.');
                } else if (!self.isValidEmail(self.form_confirm_mail.email)) {
                    $eventbus.$emit('open:alert', 'Merci de préciser une adresse e-mail valide.');
                } else {
                    Autentification.reset_password({
                        kta_id: '',
                        email: self.form_confirm_mail.email
                    })
                        .then(function (result) {
                            var data = result.data;

                            if (data && data.error) {
                                $eventbus.$emit('open:alert', data.error.message);
                            } else {
                                // $eventbus.$emit('open:reset-password-v2');
                                $eventbus.$emit('open:alert', 'Vérifier votre adresse email pour actualiser le mot de passe');
                                $eventbus.$emit('hide:modal');


                                let sto = setTimeout(function(){
                                    clearTimeout(sto);

                                    if(window.parent && window.parent.MainFrame){
                                            let MainFrame = window.parent.MainFrame;
                                            let mailSentTrigger = 'mailSentFromForm';

                                            MainFrame.Manager.Variables.register("loggedOut", "1");

                                            MainFrame.Manager.Variables.register("api_token", "0");
                                            MainFrame.EprintShop.saveItem("api_token", null);

                                            // MainFrame.EventHandler.dispatch(mailSentTrigger);
                                            MainFrame.EventHandler.dispatch('closeLogin');
                                            MainFrame.EventHandler.dispatch('loginSuccess');
                                            MainFrame.EventHandler.dispatch("userNotLoggedIn");
                                        }

                                },4000);

                            }
                        })
                        .catch(function (error) {
                            $eventbus.$emit('open:alert', 'Le formulaire comporte une erreur. Veuillez vérifier les informations.');
                        })
                        .then(function () {
                            self.clearConfirmMail();
                        });
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    #confirmMail_v2 {
        width: 100%;
        max-width: 350px;
        padding: 1rem 0;
        .confirm_mail_title {
            font-size: 22px;
            font-weight: bold;
        }
        .confirm_mail_auth {
            * {
                user-select: none;
            }
            p {
                font-size: 12px;
                color: #6b6c6f;
            }
            .input_wrapper {
                position: relative;
                input {
                    width: 100%;
                    border: 1px solid #dfe2e6;
                    border-radius: 25px;
                    padding-block: 0.3rem;
                    padding-inline: 3rem;
                    outline: none;
                    font-size: 13px;
                    color: #6b6c6f;
                    &::placeholder {
                        font-weight: bold;
                        opacity: 0.5;
                        font-size: 13px;
                    }
                    &:focus {
                        border-color: #6b6c6f;
                    }
                }
                .email_img_wrapper {
                    position: absolute;
                    top: 50%;
                    left: 25px;
                    translate: -50% -50%;
                    width: 20px;
                    img {
                        width: 100%;
                        display: block;
                        height: auto;
                    }
                }
                .key_img_wrapper {
                    position: absolute;
                    top: 50%;
                    left: 25px;
                    translate: -50% -50%;
                    width: 20px;
                    img {
                        width: 100%;
                        display: block;
                        height: auto;
                    }
                }
                .eye_img_wrapper {
                    position: absolute;
                    top: 50%;
                    right: 0.2rem;
                    translate: -50% -50%;
                    width: 16.5px;
                    img {
                        width: 100%;
                        display: block;
                        height: auto;
                    }
                }
            }
            .buttons-wrapper {
                .btn {
                    font-size: 14px;
                    outline: none;
                    border: none;
                    width: 100%;
                    max-width: 160px;
                    height: 40px;
                    border-radius: 2rem;
                    font-weight: 500;
                    user-select: none;
                    &.sign-up-btn {
                        border: 2px solid #4e4e4e;
                        color: #4e4e4e;
                    }
                    &.validate-btn {
                        color: white;
                        background-color: #4e4e4e;
                    }
                }
            }
        }
    }
</style>
